define(['angular', '../../filters/text'], function (angular) {
    return angular.module('leadModels', ['textFilters']).factory('LeadModel', [
        '$filter',
        function ($filter) {
            var LeadModel = function (lead) {
                if (typeof lead == 'undefined' || !lead) {
                    lead = {};
                }

                if (!lead.id) {
                    // Default settings for new leads
                    lead.sendAutomatedEmails = 'all';
                }

                // Get formatted attribute
                lead.attribute = function (att) {
                    var thisLead = this;
                    var autoAtt = 'auto' + att;

                    if (thisLead.hasOwnProperty(att)) {
                        switch (att) {
                            // Field that can be autofilled on the backend
                            case 'name':
                            case 'email':
                            case 'phone':
                                if (!thisLead[att]) {
                                    if (thisLead.hasOwnProperty(autoAtt)) {
                                        return thisLead[autoAtt];
                                    }
                                }
                                return thisLead[att];
                                break;
                            case 'created':
                            case 'lastInteracted':
                                return $filter('formatdate')(thisLead[att]);
                                break;
                            case 'sendAutomatedEmails':
                                switch (thisLead[att]) {
                                    case 'all':
                                        return 'Send all automated emails';
                                        break;
                                    case 'monthly_only':
                                        return 'Only send monthly emails';
                                        break;
                                    case 'not_monthly':
                                        return 'Do not send monthly emails';
                                        break;
                                    case 'none':
                                        return 'Do not send any automated emails';
                                        break;
                                    default:
                                        return thisLead[att];
                                        break;
                                }
                                break;
                            default:
                                return thisLead[att];
                        }
                    } else if (thisLead.hasOwnProperty(autoAtt)) {
                        return thisLead[autoAtt];
                    } else {
                        var split = att.split('.');
                        var output = thisLead;

                        for (var i = 0; i < split.length; i++) {
                            if (output.hasOwnProperty(split[i])) {
                                output = output[split[i]];
                            } else {
                                return null;
                            }
                        }

                        if (output != thisLead) {
                            return output;
                        }
                    }

                    return null;
                };

                lead.delete = function (callback) {
                    var thisLead = this;

                    if (thisLead.id) {
                        var request = thisLead.$delete({ id: thisLead.id });
                        if (typeof callback == 'function') {
                            request.then(callback);
                        }
                    } else {
                        if (typeof callback == 'function') {
                            callback();
                        }
                    }
                };

                lead.save = function (callback) {
                    var thisLead = this;

                    if (thisLead.created) {
                        thisLead.created = $filter('date2save')(
                            thisLead.created
                        );
                    }

                    if (thisLead.lastInteracted) {
                        thisLead.lastInteracted = $filter('date2save')(
                            thisLead.lastInteracted
                        );
                    }

                    if (
                        thisLead.hasOwnProperty('address') &&
                        thisLead.address.hasOwnProperty('formatted_address')
                    ) {
                        thisLead.address = thisLead.address.formatted_address;
                    }

                    var request;
                    if (thisLead.id) {
                        request = thisLead.$update({ id: thisLead.id });
                    } else {
                        request = thisLead.$save();
                    }
                    request.then(function (data) {
                        thisLead.updateData(data);
                        if (typeof callback == 'function') {
                            callback();
                        }
                    });
                    return request;
                };

                lead.updateData = function (data) {
                    var thisLead = this;

                    if (data) {
                        for (var key in data) {
                            this[key] = data[key];
                        }

                        if (thisLead.created) {
                            thisLead.created = $filter('text2date')(
                                thisLead.created
                            );
                        }

                        if (thisLead.lastInteracted) {
                            thisLead.lastInteracted = $filter('text2date')(
                                thisLead.lastInteracted
                            );
                        }
                    } else if (thisLead.id) {
                        var newData = thisLead.$get({ id: thisLead.id });
                        newData.then(function (data) {
                            thisLead.updateData(data);
                        });
                    }
                };
                lead.updateData(lead);

                return lead;
            };
            return LeadModel;
        },
    ]);
});
